<div  class="d-inline-block" *ngVar="(metadataView$ | async) as metadataView">
  @if (metadataView) {
    <ng-container [ngTemplateOutlet]="metadataView?.authority ? linkToAuthority : (metadataView?.entityType ? textWithIcon : textWithoutIcon)"
    [ngTemplateOutletContext]="{metadataView: metadataView}"></ng-container>
  }
</div>
<ng-template class="d-flex" #linkToAuthority let-metadataView="metadataView">
  <span [dsStickyPopover]="popContent"
    [openDelay]="100"
    [closeDelay]="300"
    [animation]="true"
    [placement]="popoverPlacement ?? 'auto'"
    container="body"
    triggers="mouseenter">
    <a rel="noopener noreferrer" data-test="linkToAuthority"
      [routerLink]="[relatedDsoRoute]">
      <span dsEntityIcon
        [iconPosition]="iconPosition"
        [entityType]="metadataView.entityType"
        [entityStyle]="metadataView.entityStyle">
        {{metadataView.value}}
      </span>
    </a>
  </span>
  @if (metadataView.orcidAuthenticated) {
    <img
      placement="top"
      ngbTooltip="{{ metadataView.orcidAuthenticated }}"
      class="orcid-icon"
      [alt]="'metadata-link-view.orcid.logo' | translate"
      src="assets/images/orcid.logo.icon.svg"
      data-test="orcidIcon"/>
  }
</ng-template>

<ng-template #textWithIcon let-metadataView="metadataView">
  <span dsEntityIcon
    data-test="textWithIcon"
    [iconPosition]="iconPosition"
    [entityType]="metadataView.entityType"
    [entityStyle]="metadataView.entityStyle"
    [fallbackOnDefault]="false">{{normalizeValue(metadataView.value)}}</span>
</ng-template>

<ng-template #textWithoutIcon let-metadataView="metadataView">
  <span data-test="textWithoutIcon">{{normalizeValue(metadataView.value)}}</span>
</ng-template>

<ng-template #popContent>
  <ds-metadata-link-view-popover [item]="relatedItem"></ds-metadata-link-view-popover>
</ng-template>

